import { render } from "./index.vue?vue&type=template&id=46d45044"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=46d45044&lang=scss"
script.render = render

export default script